export class Program {
	static init() {
		
		$('.scroll-list__list').slick({
			slidesToShow: 4,
			slidesToScroll: 4,
			autoplay: false,
			autoplaySpeed: 3000,
			infinite: false,
			dots: true,
			responsive: [
				{
					breakpoint: 765,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
			]
		});
	}
}
